export default "__VITE_ASSET__D5rkB0wk__"